module.exports = "/_next/static/images/14cd38a11fd0648198bcae84f95e05ae-cajita-con-cdt-nu.png";